class MediaStreamTracker {
  private streams: Map<string, MediaStream> = new Map();
  private streamCounter = 0;

  addStream(stream: MediaStream, source: string): string {
    const id = `${source}_${++this.streamCounter}`;
    this.streams.set(id, stream);

    stream.getTracks().forEach((track) => {
      track.addEventListener('ended', () => {
        this.removeStream(id);
      });
    });

    return id;
  }

  removeStream(id: string): void {
    const stream = this.streams.get(id);
    if (stream) {
      stream.getTracks().forEach((track) => {
        if (track.readyState === 'live') {
          track.stop();
        }
      });
      this.streams.delete(id);
    }
  }

  stopAllStreams(): void {
    this.streams.forEach((stream) => {
      stream.getTracks().forEach((track) => {
        if (track.readyState === 'live') {
          track.stop();
        }
      });
    });
    this.streams.clear();
  }

  getActiveStreams(): {
    id: string;
    trackCount: number;
    tracks: {
      kind: string;
      label: string;
      enabled: boolean;
      readyState: string;
    }[];
  }[] {
    const activeStreams: {
      id: string;
      trackCount: number;
      tracks: {
        kind: string;
        label: string;
        enabled: boolean;
        readyState: string;
      }[];
    }[] = [];
    this.streams.forEach((stream, id) => {
      const tracks = stream.getTracks().map((track) => ({
        kind: track.kind,
        label: track.label,
        enabled: track.enabled,
        readyState: track.readyState,
      }));

      if (tracks.some((t) => t.readyState === 'live')) {
        activeStreams.push({ id, trackCount: tracks.length, tracks });
      }
    });
    return activeStreams;
  }
}

export const mediaStreamTracker = new MediaStreamTracker();
